import React from "react";
import styled from "@emotion/styled";
import hamburgerIcon from "../../assets/images/Hamburger_Menu.png";
import LogoIcon from "../../assets/images/Logo_header.png";
import ArrowIcon from "../../assets/images/arrow-down.png";
import accountMenuIcon from "../../assets/images/account-menu.png";
// import LogoutIcon from '../../assets/icons/logout.svg'
import { Menu } from "antd";
import { useNavigate } from "react-router-dom";
import { responsive } from "../../utils/style";
import { css } from "@emotion/react";
import { useSelector, useDispatch } from "react-redux";
import { onGetUserInfo } from "../../stores/auth";
import useAuth from "../../utils/useAuth";

const { SubMenu } = Menu;

function Navbar(props) {
  const navigate = useNavigate();
  const [showSubMenu, setShowSubMenu] = React.useState("");
  const {
    showMenuMobile,
    setShowMenuMobile,
    showAccountMenu,
    setShowAccountMenu,
  } = props;
  const userInfo = useSelector((s) => s.auth.userInfo);
  const dispatch = useDispatch();
  const [isLogin, setIsLogin] = React.useState(false);
  const { isStaff, isStudent } = useAuth();

  React.useEffect(() => {
    setIsLogin(!!userInfo?.id);
  }, [userInfo]);

  const { currentWeek: weeks, isInformedToday } = useSelector(
    (s) => s.auth.informInfo
  );
  const isStart = weeks && weeks > 0;
  const isEnd = weeks && weeks > 16;

  const menuList = [
    {
      text: "กติกาและรางวัล",
      childs: [
        {
          text: "กติกาและการคิดคะแนน",
          link: "/scoreRules",
        },
        {
          text: "ระดับรางวัล",
          link: "/reward",
        },
      ],
    },
    {
      text: "ขอตัวช่วย",
      childs: [
        {
          text: "ดื่มดี นมวัว",
          link: "/monkHelper/milk",
        },
        {
          text: "สุขชัวร์ เพิ่มผัก",
          link: "/monkHelper/veggie",
        },
        {
          text: "รัก ออกกำลัง",
          link: "/monkHelper/move",
        },
        {
          text: "หยุดยั้ง น้ำหวาน",
          link: "/monkHelper/sweet",
        },
        {
          text: "เมื่อน้ำหนักเกิน",
          link: "/monkHelper/overWeight",
        },
        {
          text: "เมื่อน้ำหนักน้อย",
          link: "/monkHelper/lessWeight",
        },
        {
          text: "เมื่อความสูง ต่ำกว่าเกณฑ์",
          link: "/monkHelper/lessHeight",
        },
      ],
    },
    {
      text: "ชวนคิด",
      childs: [
        {
          text: "มาเป็นมิลค์ฮีโรกันเถอะ",
          link: "/article/milk?key=think",
        },
        {
          text: "เมนูผักดี๊ ดี",
          link: "/article/veggie?key=think",
        },
        {
          text: "มูฟ อีซีย์",
          link: "/article/move?key=think",
        },
        {
          text: "การผจญภัยของน้ำตาล",
          link: "/article/drink?key=think",
        },
      ],
    },
    {
      text: "ชวนอ่าน",
      childs: [
        {
          text: "ดื่มดี นมวัว",
          link: "/article/milk?key=read",
        },
        {
          text: "สุขชัวร์ เพิ่มผัก",
          link: "/article/veggie?key=read",
        },
        {
          text: "สูง ฟิต คิดเก่ง",
          link: "/article/move?key=read",
        },
        {
          text: "รู้ทัน หวานเกิน เมินน้ำตาล",
          link: "/article/drink?key=read",
        },
      ],
    },
    {
      text: isStudent ? "กรอกข้อมูลภาวะโภชนาการ" : "วิธีเช็กภาวะโภชนาการ",
      link: isStudent ? "/nutrition" : "/nutstat",
    },
  ];

  if (isStudent) {
    const isPreventInform = isInformedToday || !isStart || isEnd;
    menuList.push({
      text: "กรอกข้อมูล 4 เป้าหมาย",
      link: isPreventInform ? "#" : "/inform",
      disabled: isPreventInform,
    });
  }

  return (
    <>
      <NavbarContainer>
        <Hamberger
          src={hamburgerIcon}
          onClick={() => setShowMenuMobile(!showMenuMobile)}
        />
        <Logo src={LogoIcon} onClick={() => navigate("/")} />

        <BigLogo src={LogoIcon} onClick={() => navigate("/")} />
        <Menulist>
          {menuList.map((menu, i) => (
            <div
              onMouseEnter={() => setShowSubMenu(menu.text)}
              onMouseLeave={() => setShowSubMenu("")}
            >
              <a href={menu.link || "#"} key={i} disabled={menu.disabled}>
                {menu.text}
              </a>
              {menu.childs && <img src={ArrowIcon} alt="arrow" />}

              {menu.childs && (
                <SubMenuList show={showSubMenu === menu.text}>
                  {menu.childs.map((child, j) => (
                    <a href={child.link} disabled={child.disabled} key={j}>
                      {child.text}
                    </a>
                  ))}
                </SubMenuList>
              )}
            </div>
          ))}
        </Menulist>

        {isLogin ? (
          <AccountMenuIcon
            src={accountMenuIcon}
            onClick={() => setShowAccountMenu(!showAccountMenu)}
          />
        ) : (
          <GetStarted onClick={() => navigate("/getStarted")}>
            เริ่มใช้งาน
          </GetStarted>
        )}

        <AccountMenu show={showAccountMenu}>
          <section style={{ background: "#F7F8F9" }}>
            {isStudent && (
              <span>
                รหัส {userInfo?.personalId}
                <br />
                ชั้น ม.{userInfo?.classNo} ห้อง {userInfo?.roomNo}
              </span>
            )}
            {!isStudent && (
              <span>
                ชื่อ {userInfo?.firstname} {userInfo?.lastname}
              </span>
            )}
            <span>
              <button
                onClick={() => {
                  isStudent ? navigate("/reportMonk") : navigate("/report");
                  setShowAccountMenu(false);
                }}
                type="button"
              >
                ขอทราบผล
              </button>
            </span>
          </section>
          <a href="/profile" onClick={() => setShowAccountMenu(false)}>
            โปรไฟล์
          </a>
          {isStaff && (
            <a
              href="/genCodePassword"
              onClick={() => setShowAccountMenu(false)}
            >
              โค้ดสำหรับการเปลี่ยนรหัสผ่าน
            </a>
          )}
          <a
            href="#"
            style={{ color: "#058459" }}
            onClick={() => {
              localStorage.removeItem("token");
              navigate("/getStarted");
              setShowAccountMenu(false);
              dispatch(onGetUserInfo());
            }}
          >
            ออกจากระบบ
          </a>
        </AccountMenu>
      </NavbarContainer>
      <CustomMenu mode="inline" enable={showMenuMobile}>
        {menuList.map((menu, i) => {
          if (menu.childs) {
            return (
              <SubMenu
                key={i}
                title={menu.text}
                style={{
                  background: "#FFFFFF",
                  "&:hover": { color: "#0000" },
                }}
              >
                {menu.childs.map((child, j) => (
                  <Menu.Item
                    key={"sub" + j}
                    style={{
                      fontSize: "18px",
                      background: "#E7EAEE",
                      margin: "0",
                      height: "52px",
                    }}
                  >
                    <a href={child.link}>{child.text}</a>
                  </Menu.Item>
                ))}
              </SubMenu>
            );
          } else {
            return (
              <Menu.Item
                key={i}
                style={{ background: "#FFFFFF" }}
                className="menu-item"
              >
                <a href={menu.link} disabled={menu.disabled}>
                  {menu.text}
                </a>
              </Menu.Item>
            );
          }
        })}
      </CustomMenu>
    </>
  );
}

const AccountMenu = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;
  width: 375px;
  font-family: Noto Sans Thai, Noto Sans;
  font-style: bold;
  font-weight: 700;
  font-size: 18px;
  border: 1px solid #d0d5dd;
  box-sizing: border-box;
  border-radius: 8px;
  display: ${(props) => (props.show ? "flex" : "none")};
  position: absolute;
  z-index: 10;
  background: #ffffff;
  top: 72px;
  right: 14px;

  section {
    width: 100%;
    padding: 24px;
    display: flex;
    border-radius: 8px;
  }

  span {
    width: 50%;
    color: #64748b;
    margin: auto;
  }

  button {
    background: #ffa226;
    border-radius: 8px;
    width: 108px;
    height: 52px;
    float: right;
    border: 0;
    color: #ffffff;
    font-size: 18px;
    cursor: pointer;
  }

  a {
    margin: 0;
    padding: 10px 10px 10px 24px;
    height: 52px;
    width: 100%;
    font-weight: 400;
    color: #4b5768;
  }

  a:hover {
    color: #fc6b4b;
    font-weight: 700;
  }

  ${responsive.semiMobile(css`
    width: 100%;
    right: 0;
    border-radius: 0;
    top: 60px;
  `)}
`;

const AccountMenuIcon = styled.img`
  width: 74px;
  height: 40px;
  margin: auto 14px;

  text-align: right;
`;

const SubMenuList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 250px;
  position: relative;
  margin-left: 20px;

  border: 1px solid #d0d5dd;
  box-sizing: border-box;
  border-radius: 8px;
  display: ${(props) => (props.show ? "flex" : "none")};
  position: absolute;
  z-index: 10;
  background: #ffffff;
  top: 30px;

  a {
    margin: 0;
    padding: 10px 10px 10px 24px;
    height: 52px;
    width: 100%;
  }

  a:hover {
    background-color: #e7eaee;
  }
`;

const Menulist = styled.div`
  display: flex;
  width: fit-content;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 37px;
  height: 50px;

  ${responsive.semiMobile(css`
    display: none;
  `)}

  a {
    font-family: Noto Sans Thai, Noto Sans;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    /* identical to box height, or 144% */

    /* Neutral / 500 */

    color: #64748b;
    margin-left: 22px;

    &[disabled] {
      opacity: 0.6;
    }
  }

  img {
    width: 24px;
    margin-left: 6px;
  }
`;

const GetStarted = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 26px;
  margin: 37px 40px;

  text-align: right;

  color: #058459;

  &:hover {
    cursor: pointer;
  }

  ${responsive.semiMobile(css`
    margin: 17px 14px;
  `)}
`;

const Logo = styled.img`
  width: 105.6px;
  height: 48px;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 6px;
  display: none;

  :hover {
    cursor: pointer;
  }

  ${responsive.semiMobile(css`
    display: flex;
  `)}
`;

const BigLogo = styled.img`
  width: 160px;
  height: 72.73px;
  margin: 14px 40px;
  :hover {
    cursor: pointer;
  }

  ${responsive.semiMobile(css`
    display: none;
  `)}
`;

const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  z-index: 11;
  position: relative;
  background-color: white;
  height: 100px;

  ${responsive.semiMobile(css`
    height: 60px;
  `)}
`;

const Hamberger = styled.img`
  margin: 8px 14px;
  width: 44px;
  height: 44px;
  border-radius: 5px;
  display: none;
  &:hover {
    background-color: #f8dec8;
  }
  ${responsive.semiMobile(css`
    display: flex;
  `)}
`;

const CustomMenu = styled(Menu)`
  display: none;

  z-index: 10;
  width: 100%;
  position: absolute;
  top: ${(props) => (props.enable ? "60px" : "-300px")};
  font-family: Noto Sans Thai;
  font-size: 18px;

  transition: 0.5s ease top;

  a {
    &[disabled] {
      opacity: 0.6;
    }
  }

  ${responsive.semiMobile(css`
    display: block;
  `)}
`;

export default Navbar;
